import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_PLANNER_OVERVIEW: MijnRoute = {
    path: ':id/planner-overzicht',
    navigationEvent: 'toPlannerOverview',
    regex: /^\/beleggen\/[^/]+\/planner-overzicht$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/planner-overzicht'
};
